import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueNCPCount } from '../../../store/emarsys/action';

const useImpressionNCP = (
  firstRef: React.RefObject<HTMLElement>,
  sectionName: string = '',
  pageTitle: string = '',
  carModel: string = '',
  menu: string = ''
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };
  const { selectedCarVariantData } = useSelector((state: IRootState) => state.newCar) || {
    selectedCarVariantData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isNCPActive = getFlagValue(FLAG_ENUM.EMARSYS_NEW_CAR_PURCHASE_PDP);
      if (isAuth && isFlagActive && isNCPActive) {
        const carColor = selectedCarVariantData?.variantOptionQualifiers?.find((item) =>
          item?.name?.includes('COLOR_T')
        );
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'pdp',
          page_title: pageTitle,
          page_url: window.location.href,
          section_name: sectionName,
          menu_cat_lvl1: 'MOBIL BARU',
          menu_cat_lvl2: selectedCarVariantData?.bodyType?.toUpperCase() || '',
          menu_cat_lvl3: carModel?.toUpperCase() || '',
          menu_cat_lvl4: menu?.toUpperCase() || '',
          sku: selectedCarVariantData.code || '',
          sku_division: '01',
          sku_price: (
            selectedCarVariantData?.strikeThroughPrice?.value ||
            selectedCarVariantData?.price?.value ||
            0
          ).toString(),
          sku_disc_price: (selectedCarVariantData?.strikeThroughPrice?.value
            ? selectedCarVariantData?.price?.value -
              selectedCarVariantData?.strikeThroughPrice?.value
            : 0
          ).toString(),
          sku_base_price: (selectedCarVariantData?.price?.value || 0).toString(),
          car_category: selectedCarVariantData?.bodyType || '',
          car_model: carModel || '',
          car_type: selectedCarVariantData.name || '',
          car_color: carColor?.value || '',
          material_name: selectedCarVariantData.code || '',
        };

        if (selectedCarVariantData?.code?.split('_')?.length > 1) {
          valuePageView.car_colorcode = selectedCarVariantData?.code?.split('_')[1];
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueNCPCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-60px 0px -70px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 60,
    isLargeScreen ? 0 : 70
  );

  return null;
};

export default useImpressionNCP;
